export default function unique(list, property) {
  function propertyful(item, index) {
    return list.indexOf(list.find(i => i[property] === item[property])) === index;
  }

  function propertyless(item, index) {
    return list.indexOf(item) === index;
  }

  return list.filter(property ? propertyful : propertyless);
}
